import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
    // 菜单设置里菜单发生变化刷新菜单
    refreshMenus:false,
    userInfo:{},
    // 所有子系统
    allSystems: {
        list1:[],
        list2:[]
    },
    // 当前子系统
    currentSystem:{},
    // 左侧菜单列表
    leftMenus:[],
    // 左侧菜单栏缩放
    isFoldMenu:false,
    // 打开过的labels menus
    openMenus:[],
    // 当前打开的menu
    currentMenu:{},
    globalLoading:false,
    //控制operatepanel隐藏显示状态
    isReplaySearch:true,
    //搜索条件
    searchTerms:{},
    //当前系统时间
    currentSystemTime:0,
    navNum:{}
}
const mutations = {
    SET_USER_INFO(state,obj){
      state.userInfo = obj
    },
    SET_CURRENT_SYSTEM_TIME(state,time){
        state.currentSystemTime = time
    },
    SET_ALL_SYSTEMS(state,arr){
        state.allSystems = arr
    },
    SET_NAV_NUM(state,obj){
        state.navNum = obj
    },
    SET_SEARCH_TERMS(state,obj){
        state.searchTerms[obj.path] = obj.search
    },
    SET_CURRENT_SYSTEM(state,system){
        state.currentSystem = system
    },
    SET_REFRESH_MENUS(state,boo){
        state.refreshMenus = boo
    },
    SET_LEFT_MENUS(state,menus){
        state.leftMenus = menus
    },
    SET_IS_FOLD_MENU(state,fold){
        state.isFoldMenu = fold
    },
    ADD_OPEN_MENU(state,menu){
        let isMenu = true;
        state.openMenus.map(v=>{
            if(v.id === menu.id){
                isMenu = false
            }
        })
        if(isMenu){
            state.openMenus.unshift(menu)
        }
    },
    DEL_OPEN_MENU(state,menuid){
        state.openMenus.map((v,index)=>{
            if(v.id === menuid){
                state.openMenus.splice(index,1)
            }
        })
    },
    CLEAR_OPEN_MENU(state){
        state.openMenus = []
    },
    SET_CURRENT_MENU(state,menu){
        state.currentMenu = menu
    },
    SET_GLOBAL_LOADING(state,load){
        state.globalLoading = load
    },
    SET_REPLAY_SEARCH(state,boo){
        state.isReplaySearch = boo
    }
}
const actions = {
    //此处运用对象解构(es6)，
    //不使用对象解构的写法，第一个参数是一个对象 需要在函数里面调用对象里面的commit方法
    // setCurrentSysTime(ctx,time){
    //     ctx.commit('SET_CURRENT_SYSTEM_TIME',time)
    // },
    setUserInfo({commit},obj){
      commit('SET_USER_INFO',obj)
    },
    setCurrentSysTime({commit},time){
        commit('SET_CURRENT_SYSTEM_TIME',time)
    },
    setAllSystems({commit},arr){
        commit('SET_ALL_SYSTEMS',arr)
    },
    setNavNum ({ commit }) {
        return new Promise((resolve)=> {
            var obj = {}
            var arrUrl = [
                // {appName:'sysm',url:global.sysmUrl+'/sysm/ywtx/getManageCount'},//基础设置
                // {appName:'jxm',url:global.jxmUrl+'/jxm/ywtx/getManageCount'},//循环物资
                // {appName:'fundm',url:global.fundmUrl+'/fundm/ywtx/getManageCount'},//资金
                // {appName:'jcm',url:global.jcmUrl+'/jcm/ywtx/getManageCount'},//竞买
                // {appName:'emm',url:global.emmUrl+'/emm/ywtx/getManageCount'},//询价
                // {appName:'ecm',url:global.ecmUrl+'/ecm/ywtx/getManageCount'},//挂牌
            ]
            arrUrl.map(v=>{
                Vue.prototype.$http.get(v.url).then(res =>{
                    if (res.data.status == 3) {
                        obj[v.appName] = res.data.data
                        commit("SET_NAV_NUM",obj)
                        resolve()
                    }
                })
            })
        })
    },
    setSearchTerms({commit},obj){
        commit('SET_SEARCH_TERMS',obj)
    },
    setCurrentSystem({commit},system){
        commit('SET_CURRENT_SYSTEM',system)
    },
    setRefreshMenus({commit},boo){
        commit('SET_REFRESH_MENUS',boo)
    },
    setLeftMenus({commit},menus){
        commit('SET_LEFT_MENUS',menus)
    },
    setIsFoldMenu({commit},fold){
        commit('SET_IS_FOLD_MENU',fold)
    },
    addOpenMenu({commit},menu){
        commit('ADD_OPEN_MENU',menu)
    },
    delOpenMenu({commit},menuid){
        commit('DEL_OPEN_MENU',menuid)
    },
    clearOpenMenu({commit}){
        commit('CLEAR_OPEN_MENU')
    },
    setCurrentMenu({commit},menu){
        commit('SET_CURRENT_MENU',menu)
    },
    setGlobalLoading({commit},load){
        commit('SET_GLOBAL_LOADING',load)
    },
    setReplaySearch({commit},boo){
        commit('SET_REPLAY_SEARCH',boo)
    }
}


export default new Vuex.Store({
	state,
    mutations,
    actions,
})


// WEBPACK FOOTER //
// ./src/vuex/store.js